import c4_image1 from '@/assets/images/carrousels/carrousel4-1.jpg';
import c4_image2 from '@/assets/images/carrousels/carrousel4-2.jpg';
import c4_image3 from '@/assets/images/carrousels/carrousel4-3.jpg';
import c4_image4 from '@/assets/images/carrousels/carrousel4-4.jpg';

export const Carrousel4 = [
  {
    title: 'Développement',
    paragraph: 'La section avant frappante dégage plus que jamais un air de confiance en soi et d\'attrait en même temps. Le look énergique typique et donc la valeur de reconnaissance sont soulignés par la nouvelle génération de phares - avec une apparence high-tech impressionnante.',
    imageURL: c4_image1
  },
  {
    title: 'Entraînement intelligent',
    paragraph: 'Le design axé sur la surface donne à la vue latérale de la Classe A Berline son aura particulière. Très peu d\'évidements dans la carrosserie allongée - un design puriste qui suscite des émotions. Avec l\'élégante ligne de toit comme point fort supplémentaire.',
    imageURL: c4_image2
  },
  {
    title: 'Assistance au freinage active',
    paragraph: 'Les feux arrière en deux parties soulignent la partie arrière claire qui met l\'accent sur la largeur. Les réflecteurs arrière ont été déplacés vers le pare-chocs arrière modulaire en deux parties. Selon l\'équipement choisi, ce pare-chocs arrière est disponible avec un diffuseur noir ou avec une baguette décorative chromée et des sorties d\'échappement chromées.',
    imageURL: c4_image3
  },
  {
    title: 'Systèmes d\'aide à la conduite',
    paragraph: 'Les feux arrière en deux parties soulignent la partie arrière claire qui met l\'accent sur la largeur. Les réflecteurs arrière ont été déplacés vers le pare-chocs arrière modulaire en deux parties. Selon l\'équipement choisi, ce pare-chocs arrière est disponible avec un diffuseur noir ou avec une baguette décorative chromée et des sorties d\'échappement chromées.',
    imageURL: c4_image4
  },
];